export enum VideoSource {
  YOUTUBE = 'YOUTUBE',
  VIMEO = 'VIMEO',
  INVALID = 'INVALID',
}
